import axios from 'axios'
import Qs from 'qs'
import router from '../router'

const API_BASE = 'https://www.autoturn.net/api'

// 獲取 s_code 從 route params（與 member_info.php 的調用方式一致）
function getSCode() {
  return router.currentRoute.value.params.id || '484c6e53c712d4c510f01fdbb0258055'
}

export const newsApi = {
  // 獲取所有公告列表
  getAllNews() {
    const url = `${API_BASE}/news_list.php`

    return axios.post(url, Qs.stringify({
      s_code: getSCode()
    }), { withCredentials: true })
  },

  // 獲取單個公告詳情
  getNewsDetail(newsId) {
    const url = `${API_BASE}/news_detail.php`

    return axios.post(url, Qs.stringify({
      s_code: getSCode(),
      news_id: newsId
    }), { withCredentials: true })
  },

  // 標記公告為已讀
  markAsRead(newsId) {
    const url = `${API_BASE}/news_mark_read.php`

    return axios.post(url, Qs.stringify({
      s_code: getSCode(),
      news_id: newsId
    }), { withCredentials: true })
  },

  // 獲取最新公告用於登入彈窗
  getLatestPopup() {
    const url = `${API_BASE}/news_latest_popup.php`

    return axios.post(url, Qs.stringify({
      s_code: getSCode()
    }), { withCredentials: true })
  },

  // 檢查是否有未讀公告
  hasUnreadNews() {
    const url = `${API_BASE}/news_unread.php`

    return axios.post(url, Qs.stringify({
      s_code: getSCode()
    }), { withCredentials: true })
  }
}
